import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandler, inject, Injectable, Injector } from '@angular/core';
import { ErroresClienteService } from './errores-cliente.service';

/**
 * ErrorHandler global: sigue escribiendo en consola como el de Angular y
 * ademas reporta el error al back. Los HttpErrorResponse no se reportan aqui:
 * los 5xx/0 ya los manda el interceptor y los 4xx son reglas de negocio.
 */
@Injectable()
export class ErroresClienteHandler extends ErrorHandler {
    // Perezoso: el ErrorHandler se crea muy temprano y no debe arrastrar dependencias.
    private readonly injector = inject(Injector);

    override handleError(error: unknown): void {
        super.handleError(error);
        try {
            const real = (error as any)?.rejection ?? error;
            if (real instanceof HttpErrorResponse) return;
            this.injector.get(ErroresClienteService).reportarExcepcion(error);
        } catch {
            // Nunca romper la app por reportar.
        }
    }
}
